import React, { useContext, useEffect, useState } from "react";
import api from '../../apis/api';
import UserContext from "../../contexts/UserContext";
import { Grid } from 'semantic-ui-react';
import Organization from "./Organization";
import AssignedTickets from "./AssignedTickets";
import { useParams } from "react-router-dom";
import { useAlertsStore } from "../../store/AlertsStore";


const Dashboard = () => {

    const userContext = useContext(UserContext)
    const { org, site } = useParams()
    const { get_alerts, set_alerts} = useAlertsStore()

    const [tickets, setTickets] = useState([])

    useEffect(() => {
        let siteNames;
        if(site){
            siteNames = userContext.userInfo.site_list.filter(i => i.site === site).map(s => s.site);
        } else if(org){
            siteNames = userContext.userInfo.site_list.filter(i => i.owner === org).map(s => s.site);
        } else{
            siteNames = userContext.userInfo.site_list.map(s => s.site);
        }
        let url = "/tickets/me"
        if(userContext.userInfo.teams.includes("GridSec")){
            url = "/tickets"
        }
        api.post(url, {
            search: {"sites": { "$in": siteNames },"status": {"$in": ["new", "Pending CAB Review", "pending", "user_responded", "in_progress", "Pending Client Approval", "Approved"]}, "type": {"$ne": "alert"}},
            pagination: { 'dynamic':false, 'column': null, 'columnDirection': null, 'prevKey': null, 'prevValue': null, 'nextValue': null, 'nextKey': null, 'pageDirection': null, 'page': 0, 'size': 1000}
        }).then(r => {
            setTickets(r.data.items)
        })

        let siteIds = userContext.userInfo.site_list.map(i => i.id)
        get_alerts(siteIds, ["TRIGGERED"]).then(r => {
            set_alerts(r.data)
        })

    }, [site, org])

    if(userContext.userInfo){
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={3}>
                        <Organization org={org} tickets={tickets} />
                    </Grid.Column>
                    <Grid.Column width={13} style={{overflowY: "scroll", maxHeight: "87vh"}}>
                        {/* <Notifications /> */}
                        <AssignedTickets org={org} tickets={tickets} unassigned={tickets.filter((t) => !('assign' in t) || t.assign === '')} />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            )
    } else {
        return <></>
    }
}

export default Dashboard